module.exports = __webpack_public_path__ + "media/kanpai.421b96b5.mp3";